import axios from "axios";
import secureLocalStorage from "react-secure-storage";
// List of dashboard Data
export const get_all_dashboard_data_list = async (id) => {
    let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/dashboard-details`);
    return response.data;
}
export const get_attendance_reports= async (filterPayload) => {
    let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/get-attendance-Reports/`, {
        params: filterPayload
    });
    return response.data;
}